import * as GuestbookCommentActionTypes from '../../../constants/comments/GuestbookCommentActionTypes';

const initialState = {
    items: [],
    totalCount: null
};

const itemUpdate = (items, id, values) => items.map(item => {
	if (item.id === id) {
		item = Object.assign({}, item, values)
	}
	return item
})

const updatedItems = (state, id, values) => Object.assign({}, state, {
	items: itemUpdate(state.items, id, values)
})

const selectedItems = (items, id, select) => items.map(item => {
    if (item.id === id) {
        item = Object.assign({}, item, { selected: select })
    }
    return item
});

export default (state = initialState, action) => {
	switch (action.type) {
		case GuestbookCommentActionTypes.CLEAR_ITEMS:
            return {
                items: [],
                totalCount: null,
            }
		case GuestbookCommentActionTypes.RECEIVE_ITEMS:
			return {
				items: action.items,
				totalCount: action.totalCount
			}
		case GuestbookCommentActionTypes.SELECT_ITEM:
			return updatedItems(state, action.id, { selected: true })

		case GuestbookCommentActionTypes.DESELECT_ITEM:
			return updatedItems(state, action.id, { selected: false })

		case GuestbookCommentActionTypes.SELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if ( item.editable) {
                    	item = Object.assign({}, item, { selected: true })
                    }
					return item
				})
			})
		case GuestbookCommentActionTypes.DESELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => Object.assign({}, item, { selected: false }) )
			})
		case GuestbookCommentActionTypes.UPDATE_ITEM:
			return updatedItems(state, action.item.id, action.item)

		case GuestbookCommentActionTypes.UPDATE_SELECTED_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if (item.selected) {
						item = Object.assign({}, item, action.values)
					}
					return item
				})
			})

	}
	return state
}
